import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#202020"
        d="M12 4c4.984 0 9.13 3.449 10 8-.869 4.551-5.016 8-10 8s-9.13-3.449-10-8c.869-4.551 5.016-8 10-8zm0 14.222a8.534 8.534 0 005.188-1.746A7.972 7.972 0 0020.113 12a7.973 7.973 0 00-2.927-4.471A8.534 8.534 0 0012 5.785 8.534 8.534 0 006.814 7.53 7.973 7.973 0 003.887 12a7.972 7.972 0 002.925 4.476A8.534 8.534 0 0012 18.222zM12 16a4.245 4.245 0 01-2.941-1.172A3.924 3.924 0 017.84 12c0-1.06.438-2.078 1.218-2.828A4.245 4.245 0 0112 8c1.103 0 2.161.421 2.941 1.172A3.924 3.924 0 0116.16 12c0 1.06-.438 2.078-1.218 2.828A4.245 4.245 0 0112 16zm0-1.778c.613 0 1.2-.234 1.634-.65A2.18 2.18 0 0014.31 12a2.18 2.18 0 00-.677-1.571A2.358 2.358 0 0012 9.778c-.613 0-1.2.234-1.634.65A2.18 2.18 0 009.69 12c0 .59.244 1.155.677 1.571.433.417 1.021.651 1.634.651z"
      ></path>
    </svg>
  )
}

export default Icon
